import { Link, useNavigate } from "react-router-dom";
import '../../styles/ProjectList.css';
import { IoIosArrowBack } from "react-icons/io";
import { IoIosAdd } from "react-icons/io";
import {useProjectsContext} from "../../context/ProjectsContext";
import ProjectHeader from "../../components/common/ProjectHeader/ProjectHeader";

export default function ProjectList() {
    const navigate = useNavigate();
    const {projects} = useProjectsContext();
    
    return (
      <div className="projectlist-wrapper">
        <Link to="/offline/CreateProject" className="fixButton"><IoIosAdd /></Link>

        <ProjectHeader
        headerTitle={'Lista projektów'}
        />

        <div className="project-grid">
          {projects.map((project, index) => (
            <Link 
            to={`/offline/project/${index}`} 
            className="project-tile" 
            key={index}>
              <h3>{project.title}</h3>
              <span>{project.actualwords}/{project.words}</span>
              <progress value={project.actualwords} max={project.words} />
            </Link>
          ))}
        </div>
        

        <Link to="/" className="BackfixButton"><IoIosArrowBack /></Link>
      </div>

       
    )

}